export function netAmount(row) {
    return Math.round((row.amount - row.tax) * 100) / 100;
}
